import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { RTF } from "../elements/RTF";
import { Separator } from "../elements/Separator";
import { useEntryAnimation } from "../hooks/Visibility";
import {
  MainShortWidthClassName,
  MainWideTextClassName,
  MainWidthClassName,
  SectionPaddingClassName,
} from "../styles";

export const SmallSectionHero: React.FC<{
  title?: string | null;
  heading?: string | null;
  className?: string;
  image?: IGatsbyImageData | null;
  svg?: IGatsbySvg;
  alt?: string | null;
  message?: IRichTextInformation | null;
}> = ({ title, heading, className, image, svg, alt, message }) => {
  const hasImage = image ?? svg;
  const [sectionRef, animationMode] = useEntryAnimation();
  return (
    <section
      ref={sectionRef}
      className={classNames(
        "page-grid max-width auto-rows-max",
        SectionPaddingClassName,
        className,
      )}
      data-component="Small Section Hero"
    >
      {title && (
        <h3
          className={classNames(
            "h3 text-hyacinth",
            MainWidthClassName,
            animationMode,
            "animate-appear",
          )}
        >
          {title}
        </h3>
      )}
      {heading && (
        <h2
          className={classNames(
            "h1 mt-20px lg:mt-40px",
            MainShortWidthClassName,
            animationMode,
            "animate-appear",
          )}
        >
          {heading}
        </h2>
      )}
      {hasImage && (
        <div
          className={classNames(
            MainWidthClassName,
            "my-30px",
            "lg:my-40px",
            "aspect-h-9",
            "aspect-w-16",
            animationMode,
            "animate-appear",
          )}
        >
          {image && (
            <GatsbyImage
              style={{ position: "absolute" }}
              image={image}
              alt={alt ?? "Sub Section Hero Image"}
              objectFit="contain"
              objectPosition="center"
              loading="lazy"
            />
          )}
          {svg && (
            <img
              src={svg.encoded ?? svg.encodedUrl}
              className="absolute h-full w-full"
              alt={alt ?? "Sub Section Hero Image"}
            />
          )}
        </div>
      )}
      {message && (
        <>
          <RTF
            className={classNames(
              MainWideTextClassName,
              animationMode,
              "animate-appear",
            )}
            fixedParagraphClassName="h5"
            content={message}
          />
          <Separator
            className={classNames(MainWideTextClassName)}
            colorClass="text-hyacinth"
          />
        </>
      )}
    </section>
  );
};
